import {createHttpLink} from '@apollo/client'

const uri = "/graphql"

const httpLink = createHttpLink({
  uri,
})

export default httpLink
